import API from "./restAPI";
import { AxiosResponse } from "axios";

let config = require("../configuration.json");

export function apiGetDiscounts(): Promise<AxiosResponse> {
  return API.get(`${config.serverUrl}/api/discounts`);
}

export function apiGetDiscountsForSeller(sellrId: number): Promise<AxiosResponse> {
  return API.get(`${config.serverUrl}/api/discounts/seller/${sellrId}`);
}

export function apiGetDiscountGroups(): Promise<AxiosResponse> {
  return API.get(`${config.serverUrl}/api/discount/groups`);
}

export function apiGetDiscountGroupsByType(type: string): Promise<AxiosResponse> {
  return API.get(`${config.serverUrl}/api/discount/groups/${type}`);
}

export function apiGetDiscountDetails(id: any): Promise<AxiosResponse> {
  return API.get(`${config.serverUrl}/api/discount/${id}`);
}

export function apiCreateOrUpdateDiscount(data: any): Promise<AxiosResponse> {
  return API.post(`${config.serverUrl}/api/discountcreateorupdate`, data);
}

export function apiDeleteDiscount(id: any): Promise<AxiosResponse> {
  return API.delete(`${config.serverUrl}/api/discount/${id}`);
}
